import React from 'react';
import { PantsColor } from '@/types';

interface GamificationBadgeProps {
  level: PantsColor;
  points?: number;
  showLabel?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

export const PANTS_COLORS: Record<PantsColor, { hex: string; emoji: string, label: string, textColor: string }> = {
  BRANCA:  { hex: '#FFFFFF', emoji: '🤍', label: 'Calça Branca', textColor: 'text-gray-600' },
  CINZA:   { hex: '#9CA3AF', emoji: '🩶', label: 'Calça Cinza', textColor: 'text-gray-600' },
  AZUL:    { hex: '#3B82F6', emoji: '🩵', label: 'Calça Azul', textColor: 'text-blue-600' },
  PRETA:   { hex: '#1F2937', emoji: '🖤', label: 'Calça Preta', textColor: 'text-gray-900' },
  DOURADA: { hex: '#F59E0B', emoji: '⭐', label: 'Calça Dourada', textColor: 'text-amber-600' },
};

export const GamificationBadge: React.FC<GamificationBadgeProps> = ({ 
  level, 
  points, 
  showLabel = true,
  size = 'md' 
}) => {
  const config = PANTS_COLORS[level] || PANTS_COLORS['BRANCA'];

  const sizeClasses = {
    sm: 'text-xs py-0.5 px-2',
    md: 'text-sm py-1 px-3',
    lg: 'text-base py-1.5 px-4'
  };

  return (
    <div 
      className={`
        inline-flex items-center gap-1.5 rounded-full border bg-white shadow-sm
        ${sizeClasses[size]}
        ${config.textColor}
      `}
      title={points ? `${points} pontos` : undefined}
    >
      <span className="text-lg leading-none">{config.emoji}</span>
      {showLabel && <span className="font-semibold">{config.label}</span>}
      {points !== undefined && (
        <span className="ml-1 text-gray-400 font-normal border-l pl-2 text-xs">
          {points} pts
        </span>
      )}
    </div>
  );
};
